import { types } from 'mobx-state-tree';
import { ExternalApplicationSettingsModel } from './Settings/externalApplicationSettingsModel';
import { GeneralSettingsStore } from './Settings/GeneralSettingsModel';
import { MapConfigurationStore } from './Settings/mapConfigurationModel';
import { MapUrlSettingsStore } from './Settings/mapUrlSettingsModel';

export const SettingsModel = types
  .model('SettingsModel', {
    mapConfiguration: types.maybe(MapConfigurationStore),
    generalSettings: types.maybe(GeneralSettingsStore),
    externalApplicationSettings: types.maybe(ExternalApplicationSettingsModel),
    mapUrlSettings: types.maybe(MapUrlSettingsStore)
  })
  .actions(self => ({
    setSettings: settings => {
      settings.forEach(s => self.updateSettings(s.identification, s));
    },
    updateSettings: (settingsName, settings) => {
      let content = JSON.parse(settings.content);
      settings = { ...settings, ...content };
      switch (settingsName.toLowerCase()) {
        case 'mapconfiguration':
          self.mapConfiguration = MapConfigurationStore.create(settings);
          break;
        case 'externalapplicationsettings':
          self.externalApplicationSettings = ExternalApplicationSettingsModel.create(settings);
          break;
        case 'generalsettings':
          self.generalSettings = GeneralSettingsStore.create(settings);
          break;
        case 'mapurlsettings':
          self.mapUrlSettings = MapUrlSettingsStore.create(settings);
          break;
        default:
          break;
      }
    }
  }));
